import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class TeamService {
  constructor(private http: HttpClient) { }
  baseUrl = environment.apiKey;
  token = localStorage.getItem("token");
  httpOptions = {
    headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
    })
  };

  getAll(): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}Team/GetAll`, this.httpOptions)
      .pipe(
        catchError(error => throwError(() => error))
      );
  }
 BoardMembers(): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}Team/GetAllBoardMembers`, this.httpOptions)
      .pipe(
        catchError(error => throwError(() => error))
      );
  }
 getTeam(): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}Team/GetAllTeam`, this.httpOptions)
      .pipe(
        catchError(error => throwError(() => error))
      );
  }
}
